



























































































import Colors from '@components/common/colors.vue';
import Price from '@components/common/device-price.vue';
import PlaceholderImage from '@components/common/placeholder-image.vue';
import Stickers from '@components/common/stickers.vue';
import { CONFIG, urlHashes } from '@constants';
import { FacetCode, HeroDeviceCode, PageType, PdpOfferType } from '@enums';
import { Product } from '@interfaces/hybris/Product';
import { VariantOption } from '@interfaces/hybris/VariantOption';
import analytics from '@services/analytics';
import navigationService from '@services/navigation-service';
import { equalizeVerticalPackages } from '@services/utils';
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
	name: 'DeviceItem',
	components: {
		PlaceholderImage,
		Colors,
		Price,
		Stickers,
	},
	props: {
		product: {
			type: Object as PropType<Product>,
			required: true,
		},
		pageType: {
			type: Number,
			default: -1,
		},
		isAdditionalAccessories: {
			type: Boolean,
			default: false,
		},
		position: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			basePDPUrl: CONFIG.baseUrl.PDP,
		};
	},
	computed: {
		...mapState('compare', ['productsToCompare']),
		...mapState('plp', ['facets', 'currentQuery']),
		isAdditionalProduct(): boolean {
			return (this.pageType === PageType.PDP_ADDITIONAL_DEVICES ||
				this.pageType === PageType.CART_ADDITIONAL_DEVICES ||
				this.isAdditionalAccessories);
		},
		isHeroes(): boolean {
			return this.pageType === PageType.HEROES;
		},
		isAccessories(): boolean {
			return this.pageType === PageType.PLP_ACCESSORIES;
		},
		offerType(): string {
			if (!this.isHeroes) {
				return this.currentQuery
					?.includes(`${FacetCode.BASIC_OFFER}:${FacetCode.NO}`) ? PdpOfferType.TOP : PdpOfferType.BASIC;
			}
			else return this.product.heroDevice === HeroDeviceCode.TOP_OFFER ? PdpOfferType.TOP : PdpOfferType.BASIC;
		},
		pdpUrl(): string | boolean {
			const defaultVariantCode = this.product?.tmaPoVariantOptions?.[0]?.code;
			const childrenTariff = this.product?.productOfferingPrices?.[0]?.tariff?.code;
			const basicTariff = this.product?.productOfferingPrices?.[0]?.tariff?.parentCode;

			if (!this.isAdditionalProduct && !this.isAccessories) {
				return `${this.basePDPUrl}/${basicTariff}/${childrenTariff}/${defaultVariantCode}
				#${urlHashes.offerKey}=${this.offerType}`;
			}
			else return false;
		},
		brand(): string {
			return this.product.brands?.[0]?.name;
		},
		image(): string {
			return this.product.images?.[0]?.url;
		},
		imageAltText(): string {
			return this.product.images?.[0]?.altText || this.brand + this.product.name;
		},
		productInComparison(): boolean {
			return this.productsToCompare.find(product => product.code === this.product.code);
		},
		hasPromoStickers(): boolean {
			return !!this.product?.promoStickers?.length;
		},
		hasMainAttributes(): boolean {
			return !!this.product.mainAttributes?.length;
		},
		hasPrice(): boolean {
			return !!this.product.productOfferingPrices?.length;
		},
		productName(): string {
			return (!this.isAccessories && !this.isAdditionalAccessories) ? this.product.name : this.accessoryName;
		},
		accessoryName(): string {
			const productOption = this.product.tmaPoVariantOptions.find((item: VariantOption) => item.defaultVariant);

			return productOption?.name ?? '';
		},
		// Position for datalayers
		productPosition(): number {
			return this.position + 1;
		},
	},
	mounted() {
		equalizeVerticalPackages();

		if (location.pathname.toLowerCase().includes(CONFIG.baseUrl.PLP.toLowerCase()) ||
			this.pageType === PageType.HEROES)
			analytics.onPlpImpression(this.product, this.productPosition);
	},
	methods: {
		...mapActions('compare', ['toggleItemToCompare']),
		...mapActions('dataLayer', ['clickedOnDevice']),
		addToCompareProducts(product) {
			this.toggleItemToCompare({ item: product });
		},
		goToPdp(): void {
			this.pdpUrl && navigationService.goTo(this.pdpUrl.toString());
		},
		onDeviceClick(): void {
			if (!this.isAdditionalProduct && !this.isAccessories) {
				analytics.onPlpDeviceClick(this.product, this.productPosition);
				this.clickedOnDevice({ products: [this.product], position: this.productPosition });
			}
		},
	},
});
